import { inject, Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateFn,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { MuvstokAnalyticsService } from '@muvstok/ngx-muvstok';

@Injectable({ providedIn: 'root' })
export class PermissionsService {
  private authService = inject(AuthService);
  private router = inject(Router);
  private muvstokAnalyticsService = inject(MuvstokAnalyticsService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    const id = route.data['id'];

    this.muvstokAnalyticsService.setAccountData({
      accountId: this.authService.accountId,
      accountEmail: this.authService.email,
    });

    if (!id) {
      return true;
    }

    const isValid = this.authService.ValidarAction(id);

    if (!isValid) {
      this.router.navigate(['/not-authorized']);
    }

    return isValid;
  }
}

export const RoleGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): boolean => {
  return inject(PermissionsService).canActivate(next, state);
};
